































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule, authModule } from '@/store';
import { ApiError, Booking, ConfirmationEmailRequest } from '@/api';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import BookingModal from '@/components/frontend/BookingModal.vue';

@Component({
  components: { AbstractTable, BookingModal },
})
export default class extends Vue {
  selectedBookings: Booking[] = [];
  bookingModal: boolean = false;
  bookingToView: Booking | null = null;

  get windowSize() {
    return window.outerWidth;
  }

  get bookingHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Departure',
        value: 'startDatetime',
      },
      {
        text: 'Arrival',
        value: 'endDatetime',
      },
      {
        text: 'Vehicle',
        value: 'rego',
      },
      {
        text: 'Total Cost',
        value: 'totalCost',
      },
      {
        text: 'Amount Paid',
        value: 'amountPaid',
      },
    ];
  }

  get bookingScope() {
    return () =>
      Booking.includes([
        'airlineOut',
        'airlineIn',
        'extras',
        'lot',
        'vehicleType',
      ]).where({ customer: this.customerId });
  }

  get bookingDefaultOptions() {
    return Booking.defaultOptions();
  }

  get selectedBooking() {
    return this.selectedBookings[0] || null;
  }

  get customer() {
    if (!authModule.user) {
      return;
    }
    return authModule.user.customer;
  }

  get customerId() {
    if (!this.customer) {
      return;
    }
    return this.customer.id;
  }

  bookingClicked(item: Booking) {
    if (!item) {
      return;
    }

    this.viewBooking(item);
  }

  viewBooking(booking: Booking = this.selectedBooking) {
    this.bookingToView = booking;
    this.bookingModal = true;
  }

  updateBookings() {
    (this.$refs.bookingTable as AbstractTable).update();
  }

  async resendConfirm() {
    if (!this.customer) {
      return;
    }
    try {
      const confirmEmail = new ConfirmationEmailRequest({
        email: this.customer.email,
      });
      await confirmEmail.save();
      snackModule.showSnackbar('Confirmation email sent.');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  mounted() {
    if (!authModule.isLoggedIn) {
      this.$router.push({
        name: 'login',
        query: { next: window.location.pathname },
      });
    }
  }
}
